import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/one-vigilance/inteligencia-regulatoria")({
  head: () => buildRouteHead("/es/servicios/one-vigilance/inteligencia-regulatoria", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/farmacovigilancia/inteligencia-regulatoria", replace: true });
  },
});
